import React from 'react';
import { connect } from 'react-redux';
import Form from '../../FormsTemplate';
import { FormNames } from '../../Forms.constants';
import PropTypes from 'prop-types';

import UserInfoSection from '../../Sections/UserInfoSection/UserInfoSection';
import ManufacturerModelSection from '../../Sections/ManufacturerModelSection/ManufacturerModelSection';
import NoteSection from '../../Sections/NoteSection/NoteSection';
import HMISection from '../../Sections/HMISection/HMISection';
import AsFoundTestTableSection from '../../Sections/AsFoundTestTableSection/AsFoundTestTableSection';
import AsLeftTestTableSection from '../../Sections/AsLeftTestTableSection/AsLeftTestTableSection';
import TestResultSection from '../../Sections/TestResultSection/TestResultSection';
import DeviceTypesSection from '../../Sections/DeviceTypesSection/DeviceTypesSection';

const P51Form = ({ formData }) => (
    <Form
        formName={FormNames.P51}
    >
        <UserInfoSection />
        <ManufacturerModelSection />
        <DeviceTypesSection />
        <HMISection />
        <AsLeftTestTableSection />
        <AsFoundTestTableSection />
        <TestResultSection />
        <NoteSection />
    </Form>
);
const mapStateToProps = ({ Forms }) => ({
    formData: Forms.updatedFormDataObj,
});
const mapDispatchToProps = dispatch => ({
    dispatch,
});

P51Form.propTypes = {
    formData: PropTypes.object,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(P51Form);
